export const PRODUCT_NAME = 'TDS'
export const APP_VERSION = '0.1.0'
/** Default display timezone (Plan 1 prototype uses `TDS.TZ`); overridden by Settings once loaded. */
export const DEFAULT_TIMEZONE = 'Europe/Madrid'

/**
 * Keitaro's `access_data.resources` names (fixture 194, `internal/auth/rbac.go` resourceOfTag). The
 * API scopes every route by one of them — `GET /traffic_sources` needs `traffic_sources`, the click
 * AND conversion logs need `clicks`, `report/build` (list statistics, dashboard tables, exports)
 * needs `reports`, group names need `groups`. The SPA must use these exact strings: an earlier
 * version wrote its own ids (`sources`, `flows`, `click_log`, `conversions`, `export`) into
 * `access_data`, which the API never recognised, so a USER with "full access to campaigns" saw an
 * empty campaigns page (the page's `report/build` call answered 403).
 */
export type AccessResource =
  | 'dashboard'
  | 'campaigns'
  | 'landings'
  | 'offers'
  | 'traffic_sources'
  | 'streams'
  | 'clicks'
  | 'reports'
  | 'domains'
  | 'groups'
  | 'affiliate_networks'
  | 'api_keys'
  | 'trends'
  /** ATDS-only (step 0040): the CRO page for media buyers. Stored in `access_data.resources` like
   * the Keitaro ones (the API keeps unknown resource names as sent). */
  | 'cro'

export interface NavItem {
  path: string
  label: string
  /** Resource the page needs (any listed one is enough); omitted = every logged-in user. */
  modules?: AccessResource[]
  /** ADMIN only (Users, Health, Settings). */
  admin?: boolean
}

export const NAV_ITEMS: NavItem[] = [
  { path: '/dashboard', label: 'Dashboard', modules: ['dashboard'] },
  { path: '/campaigns', label: 'Campaigns', modules: ['campaigns'] },
  { path: '/landing-pages', label: 'Landing Pages', modules: ['landings'] },
  { path: '/offers', label: 'Offers', modules: ['offers'] },
  { path: '/traffic-sources', label: 'Traffic Sources', modules: ['traffic_sources'] },
  { path: '/click-log', label: 'Click Log', modules: ['clicks'] },
  { path: '/conversions', label: 'Conversions', modules: ['clicks'] },
  { path: '/domains', label: 'Domains', modules: ['domains'] },
  { path: '/cro', label: 'CRO', modules: ['cro'] },
  { path: '/users', label: 'Users', admin: true },
  { path: '/funnel', label: 'Funnel', admin: true },
  { path: '/health', label: 'Health', admin: true },
  { path: '/settings', label: 'Settings', admin: true },
  { path: '/game', label: 'Game' },
]
